const DEFAULT_PRINTER_PROFILE = {
  name: "",
  paper_width: "80",
  auto_print: false,
};

export function getPrinterProfile() {
  try {
    const stored = JSON.parse(localStorage.getItem("gloo.printer"));

    if (!stored || typeof stored !== "object") {
      return { ...DEFAULT_PRINTER_PROFILE };
    }

    return {
      ...DEFAULT_PRINTER_PROFILE,
      ...stored,
    };
  } catch {
    return { ...DEFAULT_PRINTER_PROFILE };
  }
}

export function normalizePaperWidth(value) {
  return String(value) === "58" ? "58" : "80";
}

export function getPrinterPaperWidthMm(value) {
  return `${normalizePaperWidth(value)}mm`;
}

export { DEFAULT_PRINTER_PROFILE };
